import { IconClose, IconInfoCircle } from "@suse-o11y/icons";
import React, { useState } from "react";

const DISCLAIMER_SECTIONS = [
	{
		title: "Verify All Results",
		body: "The AI may produce incorrect, incomplete, or outdated information. You are solely responsible for independently verifying the accuracy and appropriateness of all responses.",
	},
	{
		title: "Use at Your Own Risk",
		body: "Never apply commands, configurations, or technical advice to a production environment without first validating them in a safe, isolated test setting. SUSE is not liable for any damages or losses resulting from the use of information provided by this assistant.",
	},
	{
		title: "Do Not Share Secrets",
		body: "Do not input any sensitive data, credentials, API keys, or other confidential information. Do not input any data that could be used to identify a living person or any other personally identifiable information.",
	},
];

const VerifyPopover: React.FC<{ onClose: () => void }> = ({ onClose }) => (
	<div className="absolute right-0 bottom-full left-0 z-20 mb-2 rounded-xl border border-grey-300 bg-white p-4 shadow-popover">
		<button
			aria-label="Close"
			className="absolute top-2 right-2 flex size-6 cursor-pointer items-center justify-center rounded text-grey-500 hover:bg-grey-100 hover:text-grey-800"
			onClick={onClose}
			type="button"
		>
			<IconClose className="size-3.5" />
		</button>
		<div className="flex flex-col gap-4 pr-4">
			{DISCLAIMER_SECTIONS.map(({ body, title }) => (
				<div className="flex flex-col gap-1" key={title}>
					<span className="font-semibold text-grey-900 text-sm">{title}</span>
					<span className="text-grey-600 text-xs leading-relaxed">{body}</span>
				</div>
			))}
		</div>
	</div>
);

export const VerifyDisclaimer: React.FC = () => {
	const [open, setOpen] = useState(false);

	return (
		<div className="relative">
			{open && <VerifyPopover onClose={() => setOpen(false)} />}
			<div className="flex items-center gap-1.5 text-grey-600 text-xs">
				<IconInfoCircle className="size-3 shrink-0 text-grey-500" />
				<span>AI-generated responses may be incomplete or incorrect.</span>
				<button
					className="cursor-pointer font-medium text-grey-800 underline decoration-grey-400 underline-offset-2 transition-colors hover:text-primary-600"
					onClick={() => setOpen((v) => !v)}
					type="button"
				>
					Verify results.
				</button>
			</div>
		</div>
	);
};
